import { computed, defineComponent, useCssModule, useRoute } from '@nuxtjs/composition-api';
import { createHead } from '~/utils';
import { useArchive, useSearch } from '~/composables';
export default defineComponent({
    name: 'PageArchive',
    scrollToTop: true,
    setup() {
        const archive = useArchive();
        const css = useCssModule();
        const route = useRoute();
        const search = useSearch();
        const searchAttrs = computed(() => {
            const { path: to, params: { pathMatch = '' }, } = route.value;
            const archivePath = pathMatch?.replace(/\/$/, '') || '';
            const parentEntry = archivePath || search.completedQuery || search.dateRange.length || search.hasSearched
                ? {
                    title: 'Архив',
                    to: '/archive',
                }
                : 'Архив';
            if (!archivePath) {
                return {
                    entries: [parentEntry],
                    title: 'Архив',
                };
            }
            const title = archive.get(archivePath, 'title');
            const childEntry = search.completedQuery || search.dateRange.length
                ? {
                    title,
                    to,
                }
                : title;
            return {
                entries: [parentEntry, childEntry],
                title,
            };
        });
        return {
            css,
            search,
            searchAttrs,
        };
    },
    async asyncData(context) {
        const { app, env, error, route } = context;
        try {
            const title = 'Архив';
            const head = {
                canonical: env.HOST + route.path,
                title,
                url: env.HOST + route.path,
            };
            context.$page = app.$page = {
                title,
            };
            return {
                $page: context.$page,
                head,
            };
        }
        catch (e) {
            console.error(e);
            error({ statusCode: 404 });
        }
    },
    head() {
        return createHead(this.head);
    },
});
